<template>
    <aside class="menu column is-2 is-narrow-mobile is-fullheight">
        <p class="menu-label">General</p>
        <ul class="menu-list">
            <li>
                <a
                    @click="changeTo('home')"
                    :class="{'is-active': isActive('home')}"
                >Dashboard</a>
            </li>

            <li v-if="canViewContacts">
                <a
                    @click="changeTo('contacts')"
                    :class="{'is-active': isActive('contacts')}"
                >Contacts</a>
            </li>
        </ul>
    </aside>
</template>

<script>
export default {
    props: {
        currentPage: {
            type: String,
            required: true,
        },

        canViewContacts: {
            type: Boolean,
            required: true,
        },

        account: {
            type: Object,
            required: true,
        },
    },

    data () {
        return {
            page: '',
        };
    },

    computed: {
        accountId () {
            return this.account.id;
        },

    },

    watch: {
        page (val) {
            this.$emit('changePage', val);
        },
    },

    methods: {
        isActive (pageName) {
            return pageName === this.page;
        },

        getPage () {
            return this.page;
        },

        changeTo (page) {
            this.page = page;
        },
    },

    created () {
        this.page = this.currentPage;
    },
};
</script>
